export const sideBarActionTypes = {
  FACET_VALUE_CHANGED: 'FACET_VALUE_CHANGED',
  ON_TOGGLE_SLIDER: 'ON_TOGGLE_SLIDER',
  CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
  CLEAR_FACET_SECTION: 'CLEAR_FACET_SECTION',
  CLEAR_SLIDER_SECTION: 'CLEAR_SLIDER_SECTION',
  CLEAR_AND_SELECT_FACET_VALUE: 'CLEAR_AND_SELECT_FACET_VALUE',
};

export const Actions = '';
